import { glideFetch } from '../glide-fetch'
import { ITaxonomy } from '../interfaces'

export const searchTaxonomy = async (parentTaxonomyId: number): Promise<ITaxonomy[]> => {
  if (!parentTaxonomyId) {
    return []
  }

  const { hits: taxonomies } = await glideFetch(
    'taxonomies',
    getSearchTaxonomyQuery(parentTaxonomyId)
  )

  if (!taxonomies.length) {
    throw new Error(`Could not find taxonomies by parent id: ${parentTaxonomyId}`)
  }

  taxonomies.sort((a, b) => a.position - b.position)

  return taxonomies
}

///////// IMPLEMENTATION /////////

interface ISearchTaxonomyQuery {
  search: {
    parent_id: string
  }
  content: {
    expand: { all: {} }
  }
}

const getSearchTaxonomyQuery = (parentTaxonomyId: number): ISearchTaxonomyQuery => {
  return {
    search: {
      parent_id: `${parentTaxonomyId}`,
    },
    content: {
      expand: { all: {} },
    },
  }
}
